<template>
    <div class="sk-section-header">
        <div class="elem sk-section-header-title"></div>
        <div class="elem sk-section-header-search">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.66862 8.69528C9.49081 7.87991 10 6.74942 10 5.5C10 3.01472 7.98528 1 5.5 1C3.01472 1 1 3.01472 1 5.5C1 7.98528 3.01472 10 5.5 10C6.73586 10 7.85536 9.5018 8.66862 8.69528ZM8.66862 8.69528L13 13"
                    stroke="#CCCCCC" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </div>
    </div>
    <div class="sk-section-container">
        <template v-for="item in items">
            <div class="elem sk-section-container__element"></div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: 4
        };
    }
};
</script>

<style scoped lang="less">
@import "theme/moydom/less/variables.less";

.sk-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 50px;

    &-title {
        width: 175px;
        height: 40px;
        @media(max-width: @screen-sm) {
            width: 100px;
            height: 30px;
        }
    }

    &-search {
        width: 565px;
        height: 40px;
        position: relative;

        svg {
            position: absolute;
            left: 13px;
            top: 35%;
        }

        @media(max-width: @screen-sm) {
            width: 100%;
            height: 35px;
        }
    }

    @media (max-width: @screen-sm) {
        flex-wrap: wrap;
        gap: 15px;
    }

}

.sk-section-container {
    margin-top: 40px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px 50px;

    @media (max-width: @screen-sm) {
        grid-template-columns: 1fr;
        gap: 25px 50px;
        margin-top: 25px;
    }

    &__element {
        max-width: 100%;
        width: 100%;
        height: 420px;

        @media (max-width: @screen-sm) {
            height: 100px;
        }
    }
}

.elem {
    border-radius: 8px;
    background: #e7e7e7;
    position: relative;
    overflow: hidden;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(90deg,
        transparent 0%,
        #c3c3c361 30%,
        transparent 100%);
        animation: load 2s infinite;
        content: '';
    }
}

@keyframes load {
    100% {
        transform: translateX(100%);
    }
}

</style>
